module.exports = __webpack_public_path__ + "img/profile.b733cabd.svg";